export default __webpack_public_path__ + "static/media/daniednia.64d87295.svg";